import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './styles.scss'

export const ModalCardSD = styled.article`
  border: 1px solid ${({ cardColor }) => cardColor};
  background-color: ${({ cardSecondaryColor }) => cardSecondaryColor};
`

ModalCardSD.propTypes = {
  cardColor: PropTypes.string,
  cardSecondaryColor: PropTypes.string,
}

export const ModalCardTitleSD = styled.h3`
  background-color: ${({ cardColor }) => cardColor};
`

ModalCardTitleSD.propTypes = {
  cardColor: PropTypes.string,
}

function ModalCard(props) {
  const {
    className,
    title,
    rate,
    interval,
    optionalSubtext,
    redirectButtonText,
    cardColor,
    cardSecondaryColor,
    redirectLink,
    onClose,
  } = props
  const formattedRate = parseFloat(rate).toFixed(2)

  const handleRedirect = () => {
    if (!redirectLink) {
      onClose()
    } else {
      window.location.assign(redirectLink)
    }
  }

  return (
    <ModalCardSD
      className={classNames(className, styles.root)}
      cardColor={cardColor}
      cardSecondaryColor={cardSecondaryColor}
    >
      <ModalCardTitleSD
        className={styles.title}
        cardColor={cardColor}
        dangerouslySetInnerHTML={{ __html: title }}
      />

      <div
        className={styles.content}
      >
        <div
          className={styles.price}
        >
          from <span>${formattedRate}</span>/{interval}
        </div>
        <div
          className={styles.priceInfo}
        >
          <div dangerouslySetInnerHTML={{ __html: optionalSubtext }} />
        </div>
        <button
          className={styles.modalButton}
          onClick={handleRedirect}
        >
          {redirectButtonText}
        </button>
      </div>
    </ModalCardSD>
  )
}

ModalCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired,
  interval: PropTypes.string.isRequired,
  optionalSubtext: PropTypes.string,
  redirectButtonText: PropTypes.string.isRequired,
  cardColor: PropTypes.string.isRequired,
  cardSecondaryColor: PropTypes.string.isRequired,
  redirectLink: PropTypes.string,
  onClose: PropTypes.func.isRequired,
}

ModalCard.defaultProps = {
  className: '',
  redirectLink: '',
  optionalSubtext: '',
}

export default ModalCard



// WEBPACK FOOTER //
// ./components/DialogPlan/ModalCard/ModalCard.js